import React, { useEffect, useState } from "react";
import meltGF from "../../images/melt.gif";
import meltingUnit from "../../images/meltingunit.png";
import SevenSegmentDisplay from "../SevenSegmentStyle/SevenSegmentDisplay";
import "./Melt.css";
import NavigationButtons from "../NavigationButtons/NavigationButtons";

const Melt = () => {
  const [activeTab, setActiveTab] = useState("melting");

  const [data, setData] = useState({
    Stirrer_Motor_Rotation_CW_or_CCW: "0.00",
    Furnace_Coil_Temperature: "0.00",
    Furnace_Crucible_Temperature: "0.00",
    Particle_Heater_Coil_Temperature: "0.00",
    Particle_Heater_Crucible_Temperature: "0.00",
    Furnace_ON_or_OFF: "0",
    Furnace_LID_Open: "0",
    Furnace_LID_Close: "0",
    Furnace_Actuator_Forward: "0",
    Furnace_Actuator_Reverse: "0",
    Stirrer_Motor_UP: "0",
    Stirrer_Motor_DOWN: "0",
    Particle_Heater_ON_or_OFF: "0",
    Particle_Heater_Actuator_Forward: "0",
    Particle_Heater_Actuator_Reverse: "0",
    Mould_Loading_Position: "0",
    Mould_Filling_Position: "0",
    Mould_Unloading_Position: "0",
    

  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://cmti-edge.online/foundry/php/smartfoundry.php"
        );
        const jsonData = await response.json();
        setData(jsonData);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 1000);

    return () => clearInterval(interval);
  }, []);

  const updateToggleButton = (value) => {
    return value === '1' || value === 1 ? 'green' : 'red';
  };

  const updateLED = (value) => {
    return value === "1" ? "green" : "red";
  };

  return (
    <div>
      <div className="header">MELTING & POURING UNIT</div>
      <div className="flex flex-col bg-gray-200 lg:flex-row">
        <div className="flex bg-gray-200 justify-center w-full items-center">
          <NavigationButtons />
        </div>
        <div className="flex flex-wrap bg-gray-200 p-4 actives_buttons gap-4">
          <button
            className="btns transparent"
            onClick={() => setActiveTab("melting")}
          >
            Melting Unit
          </button>
          <button
            className="btns transparent"
            onClick={() => setActiveTab("parameters")}
          >
            Process Parameters
          </button>
          {/* <button
            className="btns transparent"
            onClick={() => setActiveTab("pouring")}
          >
            Pouring Unit
          </button> */}
        </div>
      </div>
      <div
        className={`container_one ${activeTab === "melting" ? "active_tab" : ""
          }`}
      >
        <div className="container_two">
          <div className="main_contents">
            {activeTab === "melting" && (
              <form className="melt_one">
                <div className="active tab-content">
                  <div className="flex-container">
                    <div className="content-right">
                      {/* <div className="parameters">
                        <h2>Stirrer Motor Rotation CW / CCW (RPM)</h2>
                        <SevenSegmentDisplay
                          value={data.Stirrer_Motor_Rotation_CW_or_CCW}
                        />
                      </div> */}
                      <div className="parameters">
                        <h2>Furnace Coil Temperature (°C)</h2>
                        <SevenSegmentDisplay
                          value={data.Furnace_Coil_Temperature}
                        />
                      </div>
                      <div className="parameters">
                        <h2>Furnace Crucible Temperature (°C)</h2>
                        <SevenSegmentDisplay
                          value={data.Furnace_Crucible_Temperature}
                        />
                      </div>
                      {/* <div className="parameters">
                        <h2>Particle Heater Coil Temperature (°C)</h2>
                        <SevenSegmentDisplay
                          value={data.Particle_Heater_Coil_Temperature}
                        />
                      </div> */}
                      {/* <div className="parameters">
                        <h2>Particle Heater Crucible Temperature (°C)</h2>
                        <SevenSegmentDisplay className="led-indicator"
                          value={data.Particle_Heater_Crucible_Temperature}
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
              </form>
            )}

            {/* {activeTab === "pouring" && (
              <form className="pour_one">
                <div className="tab-content">
                  <div className="flex-container">
                    <div className="content-right narrow-content-right">
                      <div className="parameter">
                        <h2>Mould Loading Position</h2>
                        <div
                          className="led-indicator"
                          style={{
                            backgroundColor: updateLED(
                              data.Mould_Loading_Position
                            ),
                          }}
                        ></div>
                      </div>
                      <div className="parameter">
                        <h2>Mould Filling Position</h2>
                        <div
                          className="led-indicator"
                          style={{
                            backgroundColor: updateLED(
                              data.Mould_Filling_Position
                            ),
                          }}
                        ></div>
                      </div>
                      <div className="parameter">
                        <h2>Mould Unloading Position</h2>
                        <div
                          className="led-indicator"
                          style={{
                            backgroundColor: updateLED(
                              data.Mould_Unloading_Position
                            ),
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )} */}

            {activeTab === "parameters" && (
              <div className="parameter_card">
                <div className="tab-content">
                  <div className="parameter">
                    <h2>Furnace ON / OFF</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Furnace_ON_or_OFF) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Furnace LID Open</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Furnace_LID_Open) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Furnace LID Close</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Furnace_LID_Close) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  {/* <div className="parameter">
                    <h2>Furnace Actuator Forward</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Furnace_Actuator_Forward)
                        ? "on"
                        : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Furnace Actuator Reverse</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Furnace_Actuator_Reverse)
                        ? "on"
                        : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Stirrer Motor UP</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Stirrer_Motor_UP) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Stirrer Motor DOWN</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Stirrer_Motor_DOWN) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Particle Heater ON / OFF</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Particle_Heater_ON_or_OFF)
                        ? "on"
                        : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Particle Heater Actuator Forward</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(
                        data.Particle_Heater_Actuator_Forward
                      )
                        ? "on"
                        : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameter">
                    <h2>Particle Heater Actuator Reverse</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(
                        data.Particle_Heater_Actuator_Reverse
                      )
                        ? "on"
                        : ""
                        }`}
                    ></div>
                  </div> */}
                </div>
              </div>
            )}
          </div>
          <div className="panels-container">
            <div className="left-panel panel">
              <div className="left_content">
                <div className="pour_card">
                  <img src={meltGF} alt="Mixer Motor" className="motor_image" />
                </div>
                <h2>Sand Casting Process</h2>
              </div>
            </div>
            <div className="panel right-panel">
              <div className="right_content">
                <img
                  src={meltingUnit}
                  alt="Mixer Motor"
                  className="motor_image"
                />
                <h1>Front View of Melting Unit</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex bg-[#141622] h-[70px] justify-center text-center text-sm text-white w-full items-center lg:text-xl md:text-lg sm:text-base">
        <p>
          Central Manufacturing Technology Institute, Tumkur Road,
          Bengaluru-560022, Karnataka, India © 2024 CMTI All rights reserved. ||
          <a href="https://example.com" className="hover:underline mx-2">
            Terms and Conditions
          </a>
        </p>
      </div>
    </div>
  );
};

export default Melt;
